import NewAcademicForm from "./NewAcademicForm";

export default NewAcademicForm;
